module.exports = __webpack_public_path__ + "static/ZMT_Dubai_clip-231446bf3a6d0818833f76011c24711c.mp4";